/* Responsiv hero: stillbild och huvudinnehåll först, film efter load och kaksvar.
   Nekad autoplay lämnar en synlig startknapp och försöker igen vid nytt läge. */
(function () {
  'use strict';

  const consentRoot = document.querySelector('[data-vk-consent]');
  const readyCallbacks = [];
  let pageLoaded = document.readyState === 'complete';
  let privacyReady = !consentRoot;
  let readyQueued = false;

  function pageUsable() {
    const main = document.querySelector('#MainContent');
    return pageLoaded && privacyReady && !window.__vkConsentPending &&
      (!consentRoot || consentRoot.hidden) && main && main.getClientRects().length;
  }

  function queueReady() {
    if (!pageUsable() || readyQueued) return;
    readyQueued = true;
    setTimeout(function () {
      readyQueued = false;
      if (!pageUsable()) return;
      window.requestAnimationFrame(function () {
        if (!pageUsable()) return;
        while (readyCallbacks.length) readyCallbacks.shift()();
      });
    }, 0);
  }

  function whenUsable(callback) {
    readyCallbacks.push(callback);
    queueReady();
  }

  function watch(query, listener) {
    if (query.addEventListener) query.addEventListener('change', listener);
    else if (query.addListener) query.addListener(listener);
  }

  function boot(root) {
    if (root.getAttribute('data-vk-booted')) return;
    root.setAttribute('data-vk-booted', 'true');
    const video = root.querySelector('[data-vk-hero-video-el]');
    const toggle = root.querySelector('[data-vk-hero-toggle]');
    if (!video || !window.matchMedia || !video.canPlayType('video/mp4')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 899px)');
    let userPaused = false;
    let blocked = false;
    let ready = false;

    function wants() {
      return !userPaused && !reduce.matches;
    }

    function label(paused) {
      toggle.setAttribute('aria-label', toggle.getAttribute(paused ? 'data-play' : 'data-pause'));
      toggle.querySelector('[data-vk-hero-toggle-icon]').textContent = paused ? '▶' : 'Ⅱ';
    }

    function fallback() {
      root.classList.remove('vk-hero-v--video-ready');
      if (!wants()) { toggle.hidden = true; return; }
      blocked = true;
      root.classList.add('vk-hero-v--start-needed');
      toggle.hidden = false;
      label(true);
    }

    function play() {
      if (!ready || !wants()) return;
      video.muted = true;
      video.defaultMuted = true;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(fallback);
    }

    function retry() {
      if (!wants() || !video.paused) return;
      play();
    }

    function selectSource() {
      if (!ready) return;
      root.classList.remove('vk-hero-v--video-ready', 'vk-hero-v--start-needed');
      toggle.hidden = true;
      blocked = false;
      video.pause();
      if (reduce.matches) {
        video.removeAttribute('src');
        video.load();
        return;
      }
      const source = video.getAttribute(mobile.matches ? 'data-vk-mobile' : 'data-vk-desktop');
      if (!source) return;
      video.preload = 'auto';
      video.src = source;
      video.autoplay = wants();
      video.load();
      if (wants()) play();
      else { toggle.hidden = false; label(true); }
    }

    video.addEventListener('playing', function () {
      if (!wants()) { video.pause(); return; }
      blocked = false;
      root.classList.remove('vk-hero-v--start-needed');
      root.classList.add('vk-hero-v--video-ready');
      toggle.hidden = false;
      label(false);
    });
    video.addEventListener('error', fallback);
    video.addEventListener('loadeddata', retry);
    video.addEventListener('canplay', retry);

    toggle.addEventListener('click', function () {
      userPaused = !video.paused;
      if (userPaused) video.pause();
      else { blocked = false; play(); }
      label(userPaused);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) retry();
    });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) retry(); });
      }, { threshold: 0.25 }).observe(video);
    }

    const gestures = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    function onGesture() {
      if (!blocked) { off(); return; }
      retry();
      if (!video.paused) off();
    }
    function off() {
      gestures.forEach(function (name) { window.removeEventListener(name, onGesture); });
    }
    gestures.forEach(function (name) {
      window.addEventListener(name, onGesture, { passive: true });
    });

    watch(reduce, selectSource);
    watch(mobile, selectSource);
    whenUsable(function () { ready = true; selectSource(); });
  }

  function init() {
    document.documentElement.classList.add('vk-defer-popup');
    whenUsable(function () { document.documentElement.classList.remove('vk-defer-popup'); });
    document.querySelectorAll('[data-vk-hero-video]').forEach(boot);
  }

  window.addEventListener('load', function () { pageLoaded = true; queueReady(); });
  document.addEventListener('vk:privacy-ready', function () { privacyReady = true; queueReady(); });
  document.addEventListener('vk:privacy-change', queueReady);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
